import type { FC, ReactNode } from 'react';
import React from 'react';

import {
    Container,
    Backdrop,
    ContentContainer,
    Title,
    Footer,
    Body,
} from './styled';

interface IModal {
    isOpen: boolean;
    onClose: () => void;
    className?: string;
    title?: ReactNode;
    footer?: ReactNode;
}

export const Modal: FC<IModal> = ({
    isOpen,
    onClose,
    children,
    className,
    title,
    footer,
}) =>
    (isOpen && (
        <Container className={className}>
            <Backdrop onClick={onClose} />
            <ContentContainer>
                {title && <Title>{title}</Title>}
                <Body>{children}</Body>
                {footer && <Footer>{footer}</Footer>}
            </ContentContainer>
        </Container>
    )) ||
    null;

Modal.defaultProps = {
    className: '',
    title: undefined,
    footer: undefined,
};
